export default __webpack_public_path__ + "static/media/service.e50bb865.svg";